module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/desempeno-grey.71a45bf4.svg";